import {Form} from "../../../../../utils/Form";
import {areObjectsEqual} from "../../../../../tools";
import {
    SavePhoneButtonsMutation,
    SavePhoneButtonsMutationVariables,
    useSavePhoneButtonsMutation,
} from "../../queries.generated";

export default class ButtonsForm extends Form<SavePhoneButtonsMutation, SavePhoneButtonsMutationVariables> {
    constructor(initialData: SavePhoneButtonsMutationVariables, cacheKeyPostfix?: string) {
        super("savePhoneButtons");
        this.hooks(useSavePhoneButtonsMutation, initialData, undefined, undefined, cacheKeyPostfix);
    }

    protected override copyInitialData(): SavePhoneButtonsMutationVariables {
        if (!this.initialData.buttons) return super.copyInitialData();

        const buttons = [];
        for (const button of this.initialData.buttons) {
            buttons.push({...button});
        }

        return {provisionedDeviceId: this.initialData.provisionedDeviceId, buttons};
    }

    protected override get filteredVariables(): SavePhoneButtonsMutationVariables {
        const buttons = [...this.values.buttons];

        for (const button of buttons) {
            for (const key of Object.keys(button) as (keyof typeof button)[]) {
                if (!button[key]) delete button[key];
            }
        }

        return {
            provisionedDeviceId: this.values.provisionedDeviceId,
            buttons,
        };
    }

    override get hasChanged(): boolean {
        if (this.initialData.buttons === undefined) return false;
        if (this.values.buttons === undefined) return false;

        if (this.values.buttons.length !== this.initialData.buttons.length) return true;

        for (let i = 0; i < this.values.buttons.length; i++) {
            if (!areObjectsEqual(this.values.buttons[i], this.initialData.buttons[i])) return true;
        }

        return false;
    }
}
